import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const triggerEndpoint = `${apiUrl}/smq/Trigger`;

const getResponseData = (response) => {
  const payload = response?.data;

  if (payload?.status === false) {
    throw new Error(payload.message || "Une erreur est survenue");
  }

  return payload;
};

const getErrorMessage = (error) =>
  error?.response?.data?.message ||
  error?.message ||
  "Le service des types de déclencheur est indisponible";

const TriggerService = {
  async getAll() {
    try {
      return getResponseData(await axios.get(triggerEndpoint));
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  async create(trigger) {
    try {
      return getResponseData(
        await axios.post(triggerEndpoint, {
          trigger_code: trigger.trigger_code,
          trigger_name: trigger.trigger_name,
        })
      );
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  async update(triggerId, trigger) {
    try {
      return getResponseData(
        await axios.put(`${triggerEndpoint}/${triggerId}`, {
          trigger_code: trigger.trigger_code,
          trigger_name: trigger.trigger_name,
        })
      );
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  async remove(triggerId) {
    try {
      return getResponseData(
        await axios.delete(`${triggerEndpoint}/${triggerId}`)
      );
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },
};

export default TriggerService;
